module.exports = __webpack_public_path__ + "img/electromagnetism_sign.b5a7c6e8.png";